export default {
  CityFormField__ARIA: "City or Town",
  CityFormField__LABEL: "City/Town",
};
